var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaspLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 759.13 333.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fb5223;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#63084b;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 686.27,
    y1: 291.3,
    x2: 679.32,
    y2: 53.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#63084b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#87184b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ab284b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#c5334b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#d53a4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#da3c4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#e24141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#f44e2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb5223"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wasp-orange"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.49,0q12.13,0,19.31,10.1,7,9.95,2.78,21.51L241.07,174.15a36.28,36.28,0,0,1-13.76,18.14A37.38,37.38,0,0,1,205.66,199h-.59a37.4,37.4,0,0,1-36.58-28.39L147.12,87.22l-21.37,83.41A37.75,37.75,0,0,1,89.17,199h-.59A37.57,37.57,0,0,1,53,174.15L1.51,31.61A22.36,22.36,0,0,1,4.44,10.1,22.28,22.28,0,0,1,23.75,0h.9A23.39,23.39,0,0,1,47,16.35L68.88,84.81Q80.7,121.59,88.29,155h.88Q93.4,134,121,20.44a25.85,25.85,0,0,1,9.34-14.75A26.17,26.17,0,0,1,146.83,0h.44a25.77,25.77,0,0,1,16.49,5.69,26.62,26.62,0,0,1,9.49,14.75Q200.69,134,205.07,155h.87q7.59-33.57,19.27-70.21l22-68.46A23.39,23.39,0,0,1,269.59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M442.4,56.14A17.19,17.19,0,0,0,429.8,51H417.33a17.53,17.53,0,0,0-17.62,17.56v.11q-9.87-22.35-35.39-22.35-30.24,0-51.66,22.35t-21.42,54.06q0,31.59,21.42,53.93T364.32,199q8.65,0,24.76-10.42a12.51,12.51,0,0,1,8.66-2,13.09,13.09,0,0,1,7.89,4.07q7.75,8.31,12.31,8.31H438a9.37,9.37,0,0,0,6.83-2.87,8.93,8.93,0,0,0,2.89-6.8V68.68A17.09,17.09,0,0,0,442.4,56.14ZM369.6,168c-19.82,0-35.9-20.15-35.9-45s16.08-45,35.9-45,35.9,20.15,35.9,45S389.43,168,369.6,168Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M474.72,175.06a15.88,15.88,0,0,1,7.87-10.24,15.62,15.62,0,0,1,12.77-1.34,79.17,79.17,0,0,0,23.3,4q19.46,0,19.45-12a11.41,11.41,0,0,0-4.45-9.35q-4.32-3.42-16.93-7.72-42.45-14.11-41.86-44.09,0-20.94,16.18-34.44,16.62-13.66,43.35-13.66a103.69,103.69,0,0,1,26.12,3.27,15.69,15.69,0,0,1,9.8,7.12,15.11,15.11,0,0,1,1.78,12l-.15.29a14.9,14.9,0,0,1-7.27,9.8,15,15,0,0,1-12.17,1.63A60.84,60.84,0,0,0,536,77.83q-17.37,0-17.37,11.73,0,5.34,5.05,8.9,4.74,3.42,18.55,8.17,39,13.5,39.49,45.27,0,21.39-15.88,34.15-16.79,13.5-47.21,13.51a114.14,114.14,0,0,1-32.8-4.61,16.08,16.08,0,0,1-9.51-7.57,15.5,15.5,0,0,1-1.63-12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M737.81,67.52q-20.73-21.3-56.24-21.3-35.24,0-56.52,21.3-19.53,19.22-21.31,52.68v11.4c.11,3.76.37,9,1,15.47v0a251.48,251.48,0,0,0,7.74,40.47c.8,2.86,2,6.39,3.56,10.46,3.39,8.91,8.42,20.36,14.18,32.86,2.79,6,5.76,12.3,8.81,18.64,2.61,5.45,5.29,11,8,16.42h0q2.79,5.7,5.57,11.26l.79,1.57c14.43,29,27.25,53.47,28.12,55.12-.52-1.62-9-26.9-15.19-55.73-.58-2.68-1.14-5.4-1.68-8.13-1.15-5.87-2.17-11.83-3-17.68-.67-4.92-1.22-9.78-1.57-14.48a112.72,112.72,0,0,1,.38-23.52c.94-6.73,2.8-12.4,5.82-16.42.06-.07.1-.14.15-.21,2.44-3.16,8.71-3.64,12.95-3.63,4.88,0,10.71.51,15.63.1a67.78,67.78,0,0,0,42.77-20.72Q757.94,154,759.13,120.2,757.93,86.78,737.81,67.52ZM681.64,167.76c-19.82,0-35.89-20.14-35.89-45s16.07-45,35.89-45,35.89,20.14,35.89,45S701.46,167.76,681.64,167.76Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 681.64,
    cy: 122.76,
    rx: 36.65,
    ry: 45.95
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaspLogo);
export default __webpack_public_path__ + "static/media/waspLogo.649aba955415c2e6e774a8e8ba7f0fab.svg";
export { ForwardRef as ReactComponent };